const folderList = [
  {id: 121, name: 'All', alias: 'all'},
  {id: 122, name: 'Frequent', alias: 'frequent'},
  {id: 124, name: 'Starred', alias: 'starred'},
];
export default folderList;
